export default {
  // null means "not fetched yet". The screen must render that differently
  // from a fetched dashboard whose tables happen to be empty -- "no ticks
  // yet" and "the request failed" must never look alike.
  dashboard: null,
  processing: false,
  error: null,
  success: null,
  // null means "nothing looked up yet". `topicMissing` is the third state:
  // a lookup that succeeded and found nothing, which must not look like
  // either "not looked up" or "the request failed".
  topic: null,
  topicMissing: false,
  // The orphaned-guid list from a requeue that asked for confirmation. Held
  // so the dialog can show it and the second press can be made deliberately.
  requeuePreview: null,
  // The orphaned-guid list from a requeue that has ALREADY run (the operator
  // confirmed it). Distinct from requeuePreview -- these videos were already
  // orphaned, not "would be orphaned if you continue" -- so this is the
  // to-do list that survives the confirm, in past tense. null means nothing
  // to show: no confirmed requeue happened yet, or the last one orphaned
  // nothing.
  requeueCompleted: null,
  // The `elsewhere` breakdown from a requeue whose reason matched no FAILED
  // rows: null means "nothing to show" (matched normally, or no reason was
  // given), [] means the reason has no jobs at all, non-empty means the
  // reason exists but only on other statuses.
  requeueElsewhere: null,
};
